import { Fragment } from "react";
import { FollowUpFlagIcon } from "shared/app/CallFollowUp";
import { Show } from "shared/components";
import { cx } from "shared/utils/classnames";
import { formatCalendar } from "views/boom-notifications/helpers/format-calendar";
import { channelConfig } from "./constants";
import { ClearFlagButton } from "./ClearFlagButton";
import { useInboxContext } from "../context/useInboxContext";
import { useInboxEmbed } from "../context/useInboxEmbed";
import { escalationLabel, type ConversationEscalation } from "../escalation";

export const EscalationBanner = ({
  conversationId,
  escalation
}: {
  conversationId?: string;
  escalation: ConversationEscalation | null;
}) => {
  const {
    actions: { selectConversation }
  } = useInboxContext();
  const compact = Boolean(useInboxEmbed()?.compact);

  if (!escalation) return null;

  const { reason, channel, at, messageId } = escalation;
  const parts = [
    escalationLabel(reason),
    channel ? (channelConfig[channel]?.label ?? channel) : null,
    at ? formatCalendar(at) : null,
    "clears when you reply"
  ].filter((part): part is string => Boolean(part));

  return (
    <div
      role="status"
      className={cx(
        "flex items-center gap-3 border-b border-danger-100 bg-danger-50 py-2 text-xs font-medium text-danger-700",
        compact ? "px-4" : "px-6"
      )}
    >
      <FollowUpFlagIcon />
      <span className="flex min-w-0 items-center truncate">
        {parts.map((part, index) => (
          <Fragment key={part}>
            {index > 0 ? <span className="mx-1.5">·</span> : null}
            <span className={index === 0 ? "font-bold" : undefined}>
              {part}
            </span>
          </Fragment>
        ))}
      </span>
      <span className="ml-auto flex shrink-0 items-center gap-3">
        <Show if={Boolean(messageId)}>
          <button
            type="button"
            onClick={() =>
              selectConversation(conversationId, messageId ?? undefined)
            }
            className="font-bold text-danger-700 hover:underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-danger-500"
          >
            See the message
          </button>
        </Show>
        <Show if={Boolean(conversationId)}>
          <ClearFlagButton
            conversationId={conversationId ?? ""}
            kind="escalation"
          />
        </Show>
      </span>
    </div>
  );
};
